import Container from './Mobile-container';

import { Kanda, Custom } from './components';

const ViewComponent = ({}) => (
  <Container>
    {({ classNames, smaller, kanda }) =>
      kanda ? <Kanda classNames={classNames} smaller={smaller} /> : <Custom />
    }
  </Container>
);

ViewComponent.displayName = 'LineItem-Mobile-view';

export default ViewComponent;
